'use client';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl'
import { FeaturesListType } from '@/types/ui';
import { TrendingUp, Wallet, People, BarChart } from '@/public/images/icons/icons';
import { fadeInUp, viewportOnce } from '@/lib/animations';


export default function WhyLoveKuik() {
    const t = useTranslations('Merchants.WhyLoveKuik');

    const features: FeaturesListType[] = [
        {
            title: 'reason_1_title',
            description: "reason_1_desc",
            icon: <TrendingUp width={30} height={30} className="shrink-0"/>,
        },
        {
            title: 'reason_2_title',
            description: "reason_2_desc",
            icon: <Wallet width={30} height={30} className="shrink-0" stroke="white"/>,
        },
        {
            title: 'reason_3_title',
            description: "reason_3_desc",
            icon: <People width={30} height={30} className="shrink-0" stroke="white"/>,
        },
        {
            title: 'reason_4_title',
            description: "reason_4_desc",
            icon: <BarChart width={30} height={30} className="shrink-0"/>,
        },
    ];

    return (
        <motion.section
            className="w-full bg-very-light py-12 px-6 sm:px-10 lg:px-16"
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            variants={fadeInUp}
        >
            <div className="max-w-8xl mx-auto">
                <div className="text-center max-w-2xl mx-auto mb-14 sm:mb-20">
                    <span className="text-xs sm:text-sm font-semibold tracking-widest color-primary uppercase">
                        {t('subtitle')}
                    </span>
                    <h2 className="text-3xl sm:text-4xl font-semibold text-black tracking-tight mt-3 leading-tight">
                        {t('title')}
                    </h2>
                </div>
                <div className="grid grid-cols-1 max-w-8xl mx-auto sm:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-6">
                    {features.map((feature: FeaturesListType, index: number) => (
                        <div key={feature.title} className="bg-white rounded-3xl p-8 shadow-lg shadow-sky-100 flex flex-col items-start transition-all hover:shadow-md hover:-translate-y-1">
                            <div className='bg-primary p-3 rounded-2xl flex items-center justify-center'>
                                {feature.icon}
                            </div>
                            <h3 className="text-lg font-bold text-black tracking-tight mb-2 min-h-[3rem] flex items-end">
                                {t(feature.title)}
                            </h3>
                            <p className="text-sm text-gray-600 leading-relaxed font-normal">
                                {t(feature.description)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </motion.section>
    );
}